export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  excerpt: string;
  content: string;
  coverImage: string;
  author: string;
  publishDate: string;
  tags: string[];
  viewCount: number;
  isHot: boolean;
}

export const categories = [
  { name: '明星八卦', slug: 'mingxing-bagua', icon: 'ri-star-line', articleCount: 2341 },
  { name: '网红黑料', slug: 'wanghong-heiliao', icon: 'ri-fire-line', articleCount: 1856 },
  { name: '综艺爆料', slug: 'zongyi-baoliao', icon: 'ri-tv-line', articleCount: 987 },
  { name: '影视吃瓜', slug: 'yingshi-chigua', icon: 'ri-film-line', articleCount: 1523 },
  { name: '社会热点', slug: 'shehui-redian', icon: 'ri-global-line', articleCount: 2109 },
  { name: '独家揭秘', slug: 'dujia-jiemi', icon: 'ri-key-2-line', articleCount: 643 },
];

export const hotArticles: Article[] = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，工作室紧急发声明否认',
    slug: 'dingliu-nanxing-shenye-mihui',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    excerpt: '据知情人士透露，该顶流男星在深夜与一名神秘女子出现在某高档酒店，两人举止亲密。随后工作室发布声明称二人仅为合作关系。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Celebrity%20male%20star%20in%20elegant%20dark%20suit%20walking%20at%20night%2C%20paparazzi%20style%2C%20dramatic%20lighting%20with%20street%20lamp%20glow%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20photography%2C%20dark%20muted%20background%20with%20bokeh%20city%20lights%2C%20editorial%20magazine%20quality%2C%20sharp%20contrast%20shadows%20on%20face&width=800&height=1060&seq=hot-article-cover-01&orientation=portrait',
    author: '吃瓜前线',
    publishDate: '2026-07-07',
    tags: ['顶流男星', '深夜密会', '恋情曝光'],
    viewCount: 128530,
    isHot: true,
  },
  {
    id: '2',
    title: '千万粉丝网红被曝偷税漏税，直播带货数据造假内幕曝光',
    slug: 'qianwan-fensi-wanghong-toushui',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    excerpt: '拥有超过两千万粉丝的头部带货网红被税务机关调查，其团队涉嫌通过虚假订单刷单制造销售假象，涉及金额高达数亿元。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Influencer%20female%20with%20luxury%20brands%20surrounding%20her%2C%20dark%20moody%20lighting%2C%20shadow%20falling%20across%20face%2C%20luxury%20handbags%20and%20shopping%20bags%20scattered%2C%20dramatic%20film%20noir%20aesthetic%2C%20investigative%20journalism%20style%2C%20high%20contrast%2C%20dark%20background%20with%20gold%20accents%2C%20editorial%20photography&width=800&height=1060&seq=hot-article-cover-02&orientation=portrait',
    author: '爆料一哥',
    publishDate: '2026-07-06',
    tags: ['偷税漏税', '数据造假', '直播带货'],
    viewCount: 95620,
    isHot: true,
  },
  {
    id: '3',
    title: '知名综艺节目现场冲突画面流出，两位导师当场翻脸互撕',
    slug: 'zhiming-zongyi-xianchang-chongtu',
    category: '综艺爆料',
    categorySlug: 'zongyi-baoliao',
    excerpt: '某选秀综艺节目录制现场，两位明星导师因选手评分问题爆发激烈争执，现场气氛一度十分紧张，节目组被迫中断录制。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20celebrities%20in%20tense%20confrontation%20on%20TV%20show%20stage%2C%20dramatic%20spotlight%20lighting%2C%20red%20and%20blue%20contrast%20stage%20lights%2C%20angry%20expressions%2C%20reality%20show%20atmosphere%2C%20dark%20studio%20background%2C%20cinematic%20wide%20shot%2C%20high%20drama%20commercial%20photography%20style&width=800&height=1060&seq=hot-article-cover-03&orientation=portrait',
    author: '综艺情报站',
    publishDate: '2026-07-06',
    tags: ['综艺节目', '导师冲突', '选秀'],
    viewCount: 78340,
    isHot: true,
  },
];

export const latestArticles: Article[] = [
  {
    id: '4',
    title: '某女星被拍到与富豪共进晚餐，疑似新恋情浮出水面',
    slug: 'nvxing-fuhao-gongjin-wancan',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    excerpt: '近日有媒体拍到知名女星与某地产富豪在高档餐厅共进晚餐，两人有说有笑，离开时还一同乘车离去。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Actress%20in%20elegant%20evening%20dress%20at%20luxury%20restaurant%20table%2C%20candlelit%20dinner%20scene%2C%20upscale%20interior%20with%20dim%20ambient%20lighting%2C%20paparazzi%20photo%20style%20through%20window%2C%20soft%20bokeh%20background%2C%20mysterious%20romantic%20atmosphere%2C%20dark%20moody%20tones%2C%20editorial%20celebrity%20photography&width=1000&height=700&seq=latest-article-cover-01&orientation=landscape',
    author: '娱乐侦探',
    publishDate: '2026-07-05',
    tags: ['女星恋情', '富豪', '约会'],
    viewCount: 65420,
    isHot: false,
  },
  {
    id: '5',
    title: '网红圈大地震！多名大V账号被封，背后原因令人震惊',
    slug: 'wanghongquan-dadizhen-fenghao',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    excerpt: '一夜之间，超过二十个百万级网红账号遭遇平台封禁，据悉与近期打击网络灰产专项行动有关，多位网红涉嫌非法引流。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Mobile%20phone%20screens%20showing%20account%20suspended%20notifications%2C%20dark%20room%20with%20multiple%20glowing%20screens%2C%20dramatic%20red%20warning%20lighting%2C%20cyberpunk%20aesthetic%2C%20social%20media%20crisis%20scene%2C%20dark%20atmospheric%20background%2C%20investigative%20tech%20photography%2C%20high%20contrast%20neon%20accents&width=1000&height=700&seq=latest-article-cover-02&orientation=landscape',
    author: '爆料一哥',
    publishDate: '2026-07-05',
    tags: ['账号封禁', '网络灰产', '专项行动'],
    viewCount: 112890,
    isHot: false,
  },
  {
    id: '6',
    title: '新剧拍摄现场花絮曝光，男女主角戏外互动亲密引猜测',
    slug: 'xinju-paishe-huaxu-baoguang',
    category: '影视吃瓜',
    categorySlug: 'yingshi-chigua',
    excerpt: '某古装大剧拍摄现场花絮流出，男女主角在休息时间互动频繁，有说有笑十分亲密，引发粉丝疯狂猜测两人是否假戏真做。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20actors%20in%20traditional%20Chinese%20costume%20drama%20on%20film%20set%2C%20laughing%20together%20between%20takes%2C%20behind%20the%20scenes%20atmosphere%2C%20warm%20golden%20hour%20backlighting%2C%20historical%20drama%20production%20set%20with%20ancient%20architecture%2C%20dark%20cinematic%20tones%2C%20intimate%20candid%20moment%2C%20editorial%20entertainment%20photography&width=1000&height=700&seq=latest-article-cover-03&orientation=landscape',
    author: '影视八卦局',
    publishDate: '2026-07-04',
    tags: ['新剧', '花絮', 'CP炒作'],
    viewCount: 45320,
    isHot: false,
  },
  {
    id: '7',
    title: '知名主持人被曝婚内出轨，小三身份竟是圈内人',
    slug: 'zhiming-zhuchiren-hunnei-chugui',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    excerpt: '某卫视知名主持人被妻子闺蜜爆料婚内出轨，出轨对象竟然是与其合作多年的搭档，两人在节目中的亲密互动原来都是真情流露。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20host%20in%20professional%20studio%20setting%20with%20dramatic%20shadow%20falling%20across%20face%2C%20dark%20broadcast%20studio%20background%20with%20equipment%2C%20split%20lighting%20half%20bright%20half%20dark%2C%20scandal%20atmosphere%2C%20newsroom%20aesthetic%2C%20high%20contrast%20moody%20portrait%2C%20investigative%20documentary%20style%20photography&width=1000&height=700&seq=latest-article-cover-04&orientation=landscape',
    author: '吃瓜前线',
    publishDate: '2026-07-04',
    tags: ['婚内出轨', '主持人', '圈内人'],
    viewCount: 167230,
    isHot: false,
  },
  {
    id: '8',
    title: '某品牌代言人翻车现场：发布会当众失态，品牌方紧急解约',
    slug: 'pinpai-daiyanren-fanche',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    excerpt: '某知名美妆品牌代言人在新品发布会现场情绪失控，对记者提问破口大骂，品牌方在事发一小时后火速发布解约声明。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Press%20conference%20scene%20with%20empty%20stage%20and%20scattered%20microphones%2C%20abandoned%20brand%20products%20on%20podium%2C%20dramatic%20lighting%20with%20long%20shadows%2C%20corporate%20crisis%20atmosphere%2C%20dark%20conference%20room%20with%20spotlight%2C%20minimal%20but%20tense%20composition%2C%20editorial%20business%20photography%2C%20high%20contrast&width=1000&height=700&seq=latest-article-cover-05&orientation=landscape',
    author: '商业八卦',
    publishDate: '2026-07-03',
    tags: ['代言翻车', '发布会', '解约'],
    viewCount: 89210,
    isHot: false,
  },
  {
    id: '9',
    title: '选秀冠军被扒学历造假，艺考成绩单疑似PS痕迹明显',
    slug: 'xuanxiu-guanjun-xueli-zaojia',
    category: '综艺爆料',
    categorySlug: 'zongyi-baoliao',
    excerpt: '近日有网友扒出去年某选秀节目冠军的学历造假证据，其自称的某名校学历在学信网无法查询，艺考成绩单也被指出有明显PS痕迹。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Diploma%20certificate%20under%20magnifying%20glass%20on%20dark%20desk%2C%20dramatic%20single%20light%20source%20from%20above%2C%20investigative%20evidence%20photography%2C%20dark%20academic%20atmosphere%2C%20forensic%20document%20examination%20scene%2C%20moody%20noir%20lighting%2C%20high%20detail%20close-up%2C%20mysterious%20suspense%20film%20style&width=1000&height=700&seq=latest-article-cover-06&orientation=landscape',
    author: '学术打假',
    publishDate: '2026-07-03',
    tags: ['学历造假', '选秀冠军', 'PS'],
    viewCount: 73450,
    isHot: false,
  },
];

export const testimonials = [
  {
    id: '1',
    name: '吃瓜达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20casual%20style%2C%20friendly%20expression%2C%20clean%20dark%20background%2C%20professional%20headshot%20photography%2C%20soft%20lighting%2C%20warm%20neutral%20tones&width=120&height=120&seq=avatar-user-01&orientation=squarish',
    role: '资深吃瓜群众',
    rating: 5,
    headline: '黑料保真，更新快',
    comment: '关注爆料吃瓜网快两年了，每次有大瓜都是这里最先更新，信息准确率很高，不像其他平台全是假消息。现在每天打开手机第一件事就是刷爆料吃瓜！',
  },
  {
    id: '2',
    name: '娱乐圈观察者',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%2C%20professional%20look%2C%20confident%20smile%2C%20clean%20dark%20background%2C%20modern%20headshot%20photography%2C%20elegant%20lighting%2C%20warm%20skin%20tones&width=120&height=120&seq=avatar-user-02&orientation=squarish',
    role: '媒体从业者',
    rating: 5,
    headline: '独家内容最全',
    comment: '作为媒体从业者，我对比过很多八卦平台，爆料吃瓜的独家内容确实是最多的。很多信息都是首发，而且有图有真相，可信度高。强烈推荐！',
  },
  {
    id: '3',
    name: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20trendy%20style%2C%20cool%20expression%2C%20clean%20dark%20background%2C%20creative%20headshot%20photography%2C%20soft%20dramatic%20lighting%2C%20neutral%20urban%20vibe&width=120&height=120&seq=avatar-user-03&orientation=squarish',
    role: '5年忠实用户',
    rating: 5,
    headline: '吃瓜氛围最好',
    comment: '用爆料吃瓜网五年了，最喜欢这里的评论区氛围，大家都很有梗。App也很好用，推送及时，界面干净没有乱七八糟的广告。吃瓜社区里的老铁们都很热情！',
  },
  {
    id: '4',
    name: '八卦研究员小李',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%2C%20intellectual%20style%20with%20glasses%2C%20gentle%20smile%2C%20clean%20dark%20background%2C%20professional%20headshot%20photography%2C%20soft%20natural%20lighting%2C%20warm%20toned&width=120&height=120&seq=avatar-user-04&orientation=squarish',
    role: '自媒体博主',
    rating: 5,
    headline: '素材来源全靠它',
    comment: '做自媒体三年了，我的素材80%来自爆料吃瓜网。这里的爆料又快又准，而且分类清晰，找素材特别方便。已经推荐给身边所有做娱乐内容的朋友了！',
  },
  {
    id: '5',
    name: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%2C%20modern%20urban%20style%2C%20relaxed%20smile%2C%20clean%20dark%20background%2C%20casual%20headshot%20photography%2C%20soft%20lighting%2C%20neutral%20skin%20tones&width=120&height=120&seq=avatar-user-05&orientation=squarish',
    role: 'App内测用户',
    rating: 4,
    headline: '每天必刷的App',
    comment: '从网站一路追到App，爆料吃瓜从来没让我失望过。最喜欢的是分类功能，想看明星看明星，想看网红看网红，非常方便。推送也做得很克制，不会轰炸式弹窗。',
  },
  {
    id: '6',
    name: '彩虹屁专业户',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%2C%20fashion%20style%2C%20bright%20smile%2C%20clean%20dark%20background%2C%20beauty%20headshot%20photography%2C%20soft%20glamour%20lighting%2C%20warm%20flattering%20tones&width=120&height=120&seq=avatar-user-06&orientation=squarish',
    role: '铁杆粉丝',
    rating: 5,
    headline: '吃瓜界的扛把子',
    comment: '全网吃瓜平台我都用过，爆料吃瓜绝对是扛把子级别的存在。内容质量、更新速度、用户体验都是第一梯队。唯一建议就是分类可以再多一些，比如增加日韩娱乐圈板块。',
  },
];